// extracted by mini-css-extract-plugin
module.exports = {"NameAndArrows":"NameAndArrows-module__NameAndArrows___3usXt","moveDown":"NameAndArrows-module__moveDown___247Ug","disable":"NameAndArrows-module__disable___3qnwh"};